import React, { useState, useEffect } from 'react';

import * as Util from '../data/General';
import DashboardCards from '../components/widget/DashboardCards';

import * as Constants from './../store/index';
import Filter from '../components/widget/Filter';
import Card from '../components/widget/Card';
import Button from '../components/html/Button';
import ChartRequest from '../components/widget/ChartRequest';


function Chatbot(props) {

  
  const [isChat, setIsChat] = useState(false);
  const [loading, setLoading] = useState(false);

  const setChat = (store) =>{
    const {moduleConfig} = store;
    for (let i = 0; i < moduleConfig.length; i++) {
      if (moduleConfig[i].name == "CHATBOT") {
        setIsChat(moduleConfig[i].active);
      }
    }
  }
  
  const [tabs, setTabs] = useState(["Dashboard", "Configuración", "Entrenamiento"]);
  const [tabsSelected, setTabsSelected] = useState(0);
  const [secondMessage, setSecondMessage] = useState(20);
  const [secondSales, setSecondSales] = useState(100);
  const [message_send, setMessageSend] = useState(100);
  const [message_ready, setMessageReady] = useState(80);
  const [sales, setSales] = useState(100);
  const [salesAmount, setSalesAmount] = useState(100);
  const [roi, setRoi] = useState(100);  
  
  let startDate = new Date();
  let endDate = new Date();
  startDate.setDate(endDate.getDate() - 360);
  
  const [filter, setFilter] = useState({
    fromNotifyDate: startDate.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'}) + "T00:00:01",
    toNotifyDate: endDate.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'})+ "T23:59:59"
  });
  const [url, setUrl] = useState("&fromNotifyDate=" +filter.fromNotifyDate + "&toNotifyDate="+filter.toNotifyDate);
  const [urlSpecial, setUrlSpecial] = useState("&fromDate=" +filter.fromNotifyDate + "&toDate="+filter.toNotifyDate);
 

  const updateFilter = (fil) => {
    setFilter(fil);
    setUrl("&fromNotifyDate=" +fil.fromNotifyDate + "&toNotifyDate="+fil.toNotifyDate+"&interval="+fil.interval);
    setUrlSpecial("&fromDate=" +fil.fromNotifyDate + "&toDate="+fil.toNotifyDate+"&interval="+fil.interval);
  }

  useEffect(() => {
    const store = Util.getAdminShop();
    setChat(store);
  }, []);



  const save = (value) => {
    setLoading(true);
    let shop = Util.getAdminShop();
    let {moduleConfig} = shop;
    let isSet = false;
    for (let i = 0; i < moduleConfig.length; i++) {
      if (moduleConfig[i].name == "CHATBOT") {
        moduleConfig[i].active = value;
        isSet = true;
      }
    }
    if(!isSet){
      moduleConfig.push({name: "CHATBOT", active: value});
    }
    shop.moduleConfig = moduleConfig;
    Util.setInfoShop(handleOkShop, handleOkShoperror, shop);
  }

  const handleOkShoperror = (data) => {
      console.log(data);
  }

  const handleOkShop = (data) => {
    if (data && data.id){
        localStorage.setItem(Constants.storage.USER_SHOP, JSON.stringify(data));
        setChat(data);
    }
    setLoading(false);
  }

  const active = () =>{
    save(true);
  }

  const inactive = () => {
    save(false);
  }

  return (
    <div className='home'>
        <div className="home">
            {isChat ? 
            (
              <>
                <Filter isIntervalShow={false} setFilter={updateFilter} filter={filter} fromText="fromNotifyDate"  toText="toNotifyDate"/>
                <div className='campaigns'>
                  <div className='content-flex space-between-start mobile-scroll flex-direction-column-mobile'>
                    <DashboardCards title={Util.getMessage("analicts_campaign_2")} second={secondMessage} count={message_send.toLocaleString(window.paramRevie.language)} textTotal={Util.getMessage("analicts_campaign_2")} percentage={message_send ? Math.trunc((message_ready * 100) / message_send) : "0"}/>
                    <DashboardCards title={"TIEMPO AHORRADO"}  count={salesAmount +50} second={secondMessage} textTotal={"MINUTOS"} />
                    <DashboardCards title={Util.getMessage("analicts_campaign_3")} extra={(sales+30) + " "+Util.getMessage("analicts_campaign_4")} second={secondSales} count={salesAmount} textTotal={Util.getMessage("analicts_campaign_3")} percentage={roi} addPercentage="x"/>
                  </div>
                </div>
                <div className='analytics chatIA'>
                  <ChartRequest title={Util.getMessage("C_1")} typeValue="int" name={"WhatsApp"} typeLabel="date" delay={10} url={"reviews/intervalstatistics?state=SENT,PENDING_APPROVAL,APPROVED,REJECTED,EXPIRED,ERROR" + url}/>
                  <ChartRequest title={Util.getMessage("C_4")} type="pie" listColors={{"MIXED":"#49A0FD","NEUTRAL":"rgb(244, 165, 0)","POSITIVE":"rgb(19, 153, 71)","NEGATIVE":"rgb(253, 87, 84)"}} pre_label="sentiment_" typeLabel="traductor" name={"Reviews"} delay={350} url={"reviews/sentimentstatistics?s=a" + urlSpecial} />
                </div>
                <div className='contect-chatbot-check' >
                    <img src="img/ia/lia.png" alt="Ilustración Lia" />
                    <div className='text-chatbox'>
                      <label className='title-chat'>Desactivá a Lia y respondé los mensajes de forma manual.</label>
                      <small>*Sin Lia, vas a tener que atender cada consulta por tu cuenta, lo que implica más tiempo dedicado a la atención, menos tiempo para hacer crecer tu negocio.</small>
                      <Button disabled={loading} value={"Desactivar"} type="primary" onClick={() => inactive()}/>
                    </div>
                </div>   
              </>
            ) : (
              <div className='cards-content-parent'>
                 <div className='cards-content'>
                    <Card 
                      img="img/ia/chatia-5.png"
                      title="Te presentamos a Lia"
                      subtitle="La IA de Revie que atiende tu Whatsapp 24/7"
                      text="Automatiza la atención, mejora la velocidad de respuesta y evita perder ventas por mensajes sin contestar"
                    />

                    <Card 
                      img="img/ia/chatia-4.png"
                      title="Mejora las ventas por campaña"
                      subtitle="Entrená a Lia antes de enviar tu campaña"
                      text="Lia con los detalles de tu campaña puede asistir a cada cliente y evitar que pierdas ventas por dudas sin responder"
                    />

                    <Card 
                      img="img/ia/chatia-6.png"
                      title="Review negativos"
                      subtitle="Lia interviene para resolver inconvenientes"
                      text="Contacta a tus clientes con reviews negativos para entender su problema y ayudarlos a mejorar su experiencia"
                    />

                    
                </div>
                <div className='cards-content'>
                    <Card 
                      img="img/ia/chatia-3.png"
                      title="Los clientes no esperan"
                      subtitle="Respuesta inmediata"
                      text="Cada mensaje es una oportunidad. Lia responde al instante para que no pierdas ninguna venta"
                    />

                    <Card 
                      img="img/ia/chatia-2.png"
                      title="Tu tienes el control"
                      subtitle="Ve el rendimiento de Lia en el inbox de Revie"
                      text="Vos decidís. Supervisá, aprobá o dejá que Lia trabaje sola. Adaptala a tu forma de vender"
                    />

                    <Card 
                      img="img/ia/chatia-1.png"
                      title="El tiempo es oro"
                      subtitle="Ahorra hasta 10 horas por semana en atención al cliente"
                      text="Lia conoce tu tienda, entiende a tus clientes y responde en tu tono. Todo al instante y sin que tengas que intervenir"
                    />
                </div>


                <div className='contect-chatbot-check'>
                    <img src="img/ia/lia.png" alt="Ilustración Lia" />
                    <div className='text-chatbox'>
                      <label className='title-chat'>Activa a Lia y deja que responda tus mensajes por vos</label>
                      <small>*Antes de activar, en la solapa Entrenamiento podés escribir mensajes como si fueras un cliente y ver cómo contesta Lia</small>
                      <Button disabled={loading} value={"Activar"} type="primary" onClick={() => active()}/>
                    </div>
                </div>

              </div>
            )}

            
          <div>

          </div>
        </div>
    </div>
  );
}

export default Chatbot;